<template>
  <v-dialog v-model="dialog" persistent max-width="490">
    <v-card class="px-2 py-2">
      <div class="d-flex align-center">
        <p class="text-left color-darkGray px-4 py-6" style="font-size: 18px">
          Após o pagamento envie o comprovante do PIX para o e-mail
          geral@ondivan.net
        </p>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="ok"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog(param = {}) {
      this.dialog = true;
    },
    ok() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.card-bord {
  border: 1px solid #707070;
  width: 400px;
  border-radius: 8px;
  padding: 6px;
}
.container-clipBoard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
}
</style>
